import { useState } from 'react'

import { currentLang, setLang, type Lang } from '../i18n'

const NAMES: Record<Lang, string> = { es: 'Español', en: 'English', ru: 'Русский' }

/** Переключатель языка до входа и в онбординге: все новые начинают на
 *  испанском, здесь можно сразу выбрать свой. onChange — перерисовать экран. */
export default function LangSwitch({ onChange }: { onChange?: (lang: Lang) => void }) {
  const [lang, setLangState] = useState<Lang>(currentLang())
  return (
    <div className="chips lang-switch" role="group" aria-label="Idioma / Language / Язык">
      {(['es', 'en', 'ru'] as const).map((value) => (
        <button
          key={value}
          className="chip"
          aria-pressed={lang === value}
          onClick={() => {
            setLang(value)
            setLangState(value)
            onChange?.(value)
          }}
        >
          {NAMES[value]}
        </button>
      ))}
    </div>
  )
}
